module.exports = "<nominas-nomina-colaboradores-resumen-colapsado\r\n    ng-if=\"!$ctrl.expandido\"\r\n    data=\"$ctrl.data\"\r\n    calculado=\"$ctrl.calculado\"\r\n    ng-click=\"$ctrl.expandido = true\"></nominas-nomina-colaboradores-resumen-colapsado>\r\n<nominas-nomina-colaboradores-resumen-extendido\r\n    ng-if=\"$ctrl.expandido\"\r\n    data=\"$ctrl.data\"\r\n    on-close=\"$ctrl.expandido = false\"></nominas-nomina-colaboradores-resumen-extendido>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/nomina/components/colaboradores/resumen/template.html
// module id = 1168
// module chunks = 0